import Link from 'next/link'
import React from 'react'
import { BannerBackgroundImage } from '~/components/search-and-results/FlightAviosOnlyBanner/BannerBackgroundImage'
import { useAviosOnlyPromotion } from '~/hooks/useAviosOnlyPromotion/useAviosOnlyPromotion'
import { pushEventToDataLayer } from '~/utils/googleTagManager'
import { useRouter } from 'next/router'
import { BannerContent } from './BannerContent'
import styles from './FlightAviosOnlyBanner.module.scss'

function trackCtaClick() {
  pushEventToDataLayer('navigation', {
    nav_type: 'cta',
    nav_action: 'avios-only reward flights book now',
  })
}

const FlightAviosOnlyBanner = () => {
  const { query } = useRouter()
  const preview = query.preview === 'true'
  const { aviosOnlyPromotionContent, isLoading } = useAviosOnlyPromotion(preview)

  if (!aviosOnlyPromotionContent || isLoading) {
    return null
  }

  const { introduction, outboundDate, inboundDate, fromAirportCode, toAirportCode, image } =
    aviosOnlyPromotionContent

  return (
    <div className={styles.aviosOnlyBanner} data-testid="flight-avios-only-banner">
      <BannerBackgroundImage url={image.file?.url as string} />

      <Link
        className={styles.aviosOnlyLink}
        title={`${introduction}`}
        onClick={trackCtaClick}
        prefetch={false}
        shallow
        href={{
          query: {
            tab: 'flights',
            departureDate: outboundDate,
            returnDate: inboundDate,
            fromAirportCode,
            toAirportCode,
            oneWayOnly: false,
          },
        }}
        data-testid="flight-avios-only-cta"
      >
        <BannerContent aviosOnlyPromotionContent={aviosOnlyPromotionContent} />
      </Link>
    </div>
  )
}

export default FlightAviosOnlyBanner
